import {
  InputGroup,
  InputLeftAddon,
  Flex,
  Input,
  Text,
  Checkbox,
} from '@chakra-ui/react';
import { UpdateSettings } from '../useCreateDataValidation';
import { ValidationRuleSettings } from '../../../../../../sheet/types';

interface AlertTextSettingsProps {
  settings: Partial<ValidationRuleSettings>;
  configKey: 'helpText' | 'invalidMessage';
  updateSettings: UpdateSettings;
}
const AlertTextSettings = ({
  settings,
  configKey,
  updateSettings,
}: AlertTextSettingsProps) => {
  const { boolKey, title, isSelected, message } = getDataFromConfigKey(
    settings,
    configKey
  );

  const renderCheckboxView = (isSelected: boolean) => (
    <Checkbox
      isChecked={isSelected}
      variant="circular"
      size="lg"
      pointerEvents="none"
    />
  );

  return (
    <InputGroup size="sm">
      <InputLeftAddon
        rounded="2xl"
        background="Background"
        cursor="pointer"
        width="120px"
        onClick={() => updateSettings({ [boolKey]: !isSelected })}
      >
        <Flex alignItems="center">
          {renderCheckboxView(isSelected)}
          <Text ml="5px" userSelect="none">
            {title}
          </Text>
        </Flex>
      </InputLeftAddon>
      <Input
        background="Background"
        type="text"
        value={message}
        autoCorrect="false"
        spellCheck="false"
        borderTopRightRadius="2xl"
        borderBottomRightRadius="2xl"
        disabled={!isSelected}
        onChange={(e) => updateSettings({ [configKey]: e.target.value })}
      />
    </InputGroup>
  );
};

function getDataFromConfigKey(
  settings: Partial<ValidationRuleSettings>,
  key: 'helpText' | 'invalidMessage'
) {
  switch (key) {
    case 'helpText':
      return {
        boolKey: 'showHelpText',
        title: 'Help Text',
        message: settings.helpText ?? 'Generate Help Text from condition',
        isSelected: !!settings.showHelpText,
      };
    case 'invalidMessage':
    default:
      return {
        boolKey: 'showAlertWhenInvalid',
        title: 'Show Alert',
        message:
          settings.invalidMessage ??
          "The value entered does not comply with the cell's data validation rules.",
        isSelected: !!settings.showAlertWhenInvalid,
      };
  }
}

export default AlertTextSettings;
